import { Link, graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect, Fragment } from "react"
import { Button, Popover } from "antd"
import {
  NavBarContainer,
  NavLinkContainer,
  NavLink
} from './styles';
import PopoverContent from './PopoverContent';

const NavigationMenu = props => {

  const [url, setUrl] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUrl(window.location.href);
    }
  }, []);

  const isPartiallyActive = () => {
    if (url) {
      return url.indexOf('/services/') >= 0 ? { className: "activeLink" } : null;
    }
  }
  //popover

  const [popoverVisible, setPopoverVisible] = useState(false);

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: {eq: "home/footer.md"}) {
        childMarkdownRemark {
          frontmatter {
            sitemapList {
              id
              title
              link
              sitemap {
                id
                link
                title
              }
            }
          }
        }
      }

      
    serviceData: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/(services)\\/.*\\\\.md$/"}}, sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            navTitle
            navIndex
            excerpt
            author
            author_image {
              childImageSharp {
                fluid {
                  src
                }
              }
              extension
              publicURL
            }
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
    }
  `);

  const popoverLink = () => {
    setPopoverVisible(false);
  };

  const onVisibleChange = visible => {
    setPopoverVisible(visible);
  };

  return (
    <Fragment>
      <NavBarContainer >
        <NavLinkContainer>
          <NavLink key="about">
            <a href="https://contentconcepts.com/about" onClick={props.onClick}>About</a>
          </NavLink>
          <NavLink key="services">
            <Popover
              overlayClassName="navPopover"
              content={<PopoverContent content={data.file.childMarkdownRemark.frontmatter} serviceData={data?.serviceData?.edges} onClick={popoverLink} />}
              visible={popoverVisible}
              onVisibleChange={onVisibleChange}
              placement="bottom"
            >
              <Link
                to="/services/academic_editing"
                getProps={isPartiallyActive}
                activeClassName="activeLink"
                onClick={props.onClick}
                onMouseOver={() => setPopoverVisible(true)}
                onFocus={() => setPopoverVisible(true)}
                id="mob-service-popover"
              >
                Services
              </Link>
            </Popover>
            <Link
              to="/services/academic_editing"
              getProps={isPartiallyActive}
              activeClassName="activeLink"
              onClick={props.onClick}
              id="mob-services-link"
            >
              Services
            </Link>
          </NavLink>
          <NavLink key="contact">
            <a href="https://contentconcepts.com/contact" activeClassName="activeLink" onClick={props.onClick} role="presentation">Contact</a>
          </NavLink>
          <NavLink key="pricing">
            <a href="https://contentconcepts.com/pricing" activeClassName="activeLink" onClick={props.onClick} role="presentation">Pricing</a>
          </NavLink>
          <NavLink key="blog">
            <a href="https://contentconcepts.com/blog" activeClassName="activeLink" onClick={props.onClick}>Blog</a>
          </NavLink>
        </NavLinkContainer>
        <a href="https://editorial.contentconcepts.com/" target="_blank" rel="noopener noreferrer">
          <Button type="primary">Submit Document</Button></a>
      </NavBarContainer>
    </Fragment>
  )
}

export default NavigationMenu
